module.exports = __webpack_public_path__ + "static/img/5e.df3e7ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5e.jpg
// module id = CGOl
// module chunks = 0